module.exports = {
  fr: {
    "Hello Vue !": "Bonjour Vue !",
    "Change Language": "Changer de langue"
  },
  es: {
    "Hello Vue !": "¡ Hola Vue !",
    "Change Language": "Cambiar de lengua"
  }
};



// WEBPACK FOOTER //
// ./src/i18n/Hello.js